const RoundDiamond = ({...props}) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      xmlSpace="preserve"
      fill="currentColor"
      {...props}
    >
      <path
        d="M97.6,50.04c0-0.01,0-0.03,0-0.04s0-0.03,0-0.04c0,0,0,0,0,0c-0.01-6.43-1.3-12.56-3.62-18.16
	c-0.01-0.03-0.01-0.07-0.02-0.1c-0.01-0.02-0.03-0.04-0.04-0.06c-2.4-5.71-5.88-10.86-10.18-15.19c-0.05-0.08-0.11-0.14-0.19-0.19
	c-4.33-4.3-9.47-7.78-15.18-10.17c-0.02-0.01-0.03-0.03-0.05-0.04c-0.03-0.01-0.06-0.01-0.1-0.02C62.6,3.69,56.45,2.4,50,2.4
	c-6.45,0-12.6,1.29-18.21,3.63c-0.03,0.01-0.07,0.01-0.1,0.02c-0.02,0.01-0.03,0.03-0.05,0.04c-5.71,2.4-10.85,5.87-15.18,10.17
	c-0.08,0.05-0.14,0.11-0.19,0.19c-4.3,4.33-7.78,9.47-10.18,15.19c-0.01,0.02-0.03,0.03-0.04,0.06c-0.02,0.03-0.01,0.07-0.02,0.1
	C3.7,37.4,2.41,43.53,2.4,49.96c0,0,0,0,0,0c0,0.01,0,0.03,0,0.04s0,0.03,0,0.04c0,0,0,0,0,0C2.41,56.47,3.7,62.6,6.03,68.2
	c0.01,0.03,0.01,0.07,0.02,0.1c0.01,0.02,0.03,0.04,0.04,0.06c2.4,5.71,5.88,10.86,10.18,15.19c0.05,0.08,0.11,0.14,0.19,0.19
	c4.33,4.3,9.47,7.78,15.18,10.17c0.02,0.01,0.03,0.03,0.05,0.04c0.03,0.01,0.06,0.01,0.09,0.02C37.4,96.3,43.55,97.6,50,97.6
	s12.6-1.3,18.21-3.63c0.03-0.01,0.06-0.01,0.09-0.02c0.02-0.01,0.03-0.03,0.05-0.04c5.71-2.4,10.85-5.87,15.18-10.17
	c0.08-0.05,0.14-0.11,0.19-0.19c4.3-4.33,7.78-9.47,10.18-15.18c0.01-0.02,0.03-0.04,0.04-0.06c0.02-0.03,0.01-0.07,0.02-0.1
	C96.3,62.6,97.59,56.47,97.6,50.04C97.6,50.04,97.6,50.04,97.6,50.04z M93.06,67.26l-9.95-4.42l13.26-11.49
	C96.21,56.95,95.05,62.31,93.06,67.26z M68.37,92.6l-4.42-9.94l17.85,1.09C77.89,87.43,73.36,90.44,68.37,92.6z M18.2,83.75
	l17.85-1.09l-4.42,9.94C26.64,90.44,22.11,87.43,18.2,83.75z M3.63,51.34l13.26,11.49l-9.95,4.42C4.95,62.31,3.79,56.95,3.63,51.34z
	 M6.94,32.74l9.95,4.42L3.63,48.66C3.79,43.05,4.95,37.69,6.94,32.74z M31.63,7.4l4.42,9.94L18.2,16.25
	C22.11,12.57,26.64,9.56,31.63,7.4z M81.8,16.25l-17.85,1.09l4.42-9.94C73.36,9.56,77.89,12.57,81.8,16.25z M96.37,48.66
	L83.11,37.16l9.95-4.42C95.05,37.69,96.21,43.05,96.37,48.66z M81.44,36.31l-15.53-2.23l-2.23-15.53l18.91-1.15L81.44,36.31z
	 M64.93,64.93L50,71.35l-14.93-6.42L28.65,50l6.42-14.93L50,28.65l14.93,6.42L71.35,50L64.93,64.93z M27.85,48.82L19.1,37.45
	l14.54-2.09L27.85,48.82z M27.85,51.18l5.79,13.46L19.1,62.55L27.85,51.18z M72.15,51.18l8.75,11.38l-14.54,2.09L72.15,51.18z
	 M72.15,48.82l-5.79-13.46l14.54,2.09L72.15,48.82z M62.55,19.1l2.09,14.54l-13.46-5.79L62.55,19.1z M50,27.24l-12.13-9.33L50,3.92
	l12.13,14L50,27.24z M48.82,27.85l-13.46,5.79l2.09-14.54L48.82,27.85z M34.09,34.09l-15.53,2.23l-1.15-18.91l18.91,1.15
	L34.09,34.09z M17.91,37.87L27.24,50l-9.33,12.13L3.92,50L17.91,37.87z M18.56,63.69l15.53,2.23l2.23,15.53l-18.91,1.15L18.56,63.69
	z M37.45,80.9l-2.09-14.54l13.46,5.79L37.45,80.9z M50,72.76l12.13,9.33L50,96.08l-12.13-14L50,72.76z M51.18,72.15l13.46-5.79
	L62.55,80.9L51.18,72.15z M65.91,65.91l15.53-2.23l1.15,18.91l-18.91-1.15L65.91,65.91z M82.09,62.13L72.76,50l9.33-12.13l14,12.13
	L82.09,62.13z M82.66,36.05l1.09-17.85c3.68,3.9,6.7,8.44,8.86,13.43L82.66,36.05z M62.83,16.89L51.34,3.63
	c5.61,0.16,10.97,1.32,15.91,3.31L62.83,16.89z M37.17,16.89l-4.42-9.95c4.94-1.99,10.3-3.15,15.91-3.31L37.17,16.89z M17.34,36.05
	L7.4,31.63c2.16-4.99,5.18-9.53,8.86-13.43L17.34,36.05z M17.34,63.95L16.25,81.8c-3.68-3.9-6.7-8.44-8.86-13.43L17.34,63.95z
	 M37.17,83.11l11.49,13.26c-5.61-0.16-10.97-1.32-15.91-3.31L37.17,83.11z M62.83,83.11l4.42,9.95c-4.94,1.99-10.3,3.15-15.91,3.31
	L62.83,83.11z M82.66,63.95l9.94,4.42c-2.16,4.99-5.18,9.53-8.86,13.43L82.66,63.95z"
      />
    </svg>
  )
}

export default RoundDiamond
